export interface PartnerFiltersValue {
  priceGroupIds: string[];
  subdivisionCode: string[];
  status: string[];
  industry: string[];
  industryCode: string;
  tags: string[];
  vatIdStatus: string[];
  riskStatus: string[];
  leadStatus: string[];
  leadSource: string[];
  supplierRating: string[];
}

export const EMPTY_PARTNER_FILTERS: PartnerFiltersValue = {
  priceGroupIds: [],
  subdivisionCode: [],
  status: [],
  industry: [],
  industryCode: '',
  tags: [],
  vatIdStatus: [],
  riskStatus: [],
  leadStatus: [],
  leadSource: [],
  supplierRating: [],
};

export function countActiveFilters(value: PartnerFiltersValue): number {
  return Object.values(value).reduce(
    (sum, filter) =>
      sum + (typeof filter === 'string' ? Number(filter.trim() !== '') : filter.length),
    0,
  );
}
